import React, { memo, forwardRef } from "react";
const SvgAlphabetP = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.73 13.61c0-.373-.06-.74-.18-1.1a2.94 2.94 0 00-.5-1 2.46 2.46 0 00-.86-.7c-.347-.187-.753-.28-1.22-.28-.44 0-.833.093-1.18.28a3.154 3.154 0 00-.9.72c-.24.293-.427.627-.56 1-.12.373-.18.747-.18 1.12 0 .373.06.747.18 1.12.133.36.32.687.56.98.253.293.553.533.9.72.347.173.74.26 1.18.26.467 0 .873-.093 1.22-.28.347-.187.633-.427.86-.72a2.94 2.94 0 00.5-1c.12-.373.18-.747.18-1.12zm2.44 0c0 .707-.113 1.373-.34 2a4.79 4.79 0 01-.94 1.62c-.4.453-.893.82-1.48 1.1-.573.267-1.227.4-1.96.4-.68 0-1.307-.14-1.88-.42-.56-.28-.993-.66-1.3-1.14h-.04v4.92c0 .28-.047.507-.14.68a.954.954 0 01-.32.42.909.909 0 01-.4.18 1.22 1.22 0 01-.34.06c-.107 0-.227-.02-.36-.06a1.064 1.064 0 01-.4-.18 1.2 1.2 0 01-.32-.42c-.08-.173-.12-.4-.12-.68V9.95c0-.267.04-.48.12-.64.093-.173.2-.307.32-.4a.914.914 0 01.36-.18c.133-.04.247-.06.34-.06.093 0 .207.02.34.06.133.027.26.087.38.18s.22.227.3.4c.093.16.14.373.14.64v.24h.06c.12-.187.273-.373.46-.56.2-.2.44-.373.72-.52.28-.16.593-.287.94-.38.36-.107.76-.16 1.2-.16.68 0 1.307.133 1.88.4a4.368 4.368 0 011.48 1.06c.413.453.733.987.96 1.6.227.613.34 1.273.34 1.98z"
      />
    </svg>
  );
});
SvgAlphabetP.displayName = "SvgAlphabetP";
const MemoForwardRef = memo(SvgAlphabetP);
export default MemoForwardRef;
